import React from "react";

export const STRINGS = {
    en: {
        infoRecord:  "Next prize: Nov 30, 2025! Guess many Pokémon as you can in 3 minutes — top player wins cash! Tap below to play!",
        dialogReward: <ul>
            <li><strong>🕹️ The goal of the game:</strong> Win a prize by finding the most Pokémon in 3 minutes flat.</li>
            <li>🔥 How to start : Register with a nickname and valid email. Once done, click on <strong>Start Timer</strong>. The timer will start.</li>
            <li><strong>📅 Monthly Challenge:</strong> Fourth winner announced on <strong>November 30, 2025</strong> </li>
            <li>💲Cash prize shared to the top scorer of each country </li>
        </ul>,
        labelDisplayPokemon: {autocomplete : 'Show Pokémon name suggestions', random : 'Random Pokémon', order: 'Sorted by Pokédex order', gen: 'By generation'},
        displayPokemon: "Choose Pokémon display mode",
        remainingPokemon: "You still have {count} Pokémon to discover!",
        foundAll: "You have found all possible Pokémon! Reset your progression to retry.",
        switchModeButton: "Switch to {mode} Mode",
        sec: "seconds",
        start: 'Start timer',
        emailPlaceholder: "Write your email",
        nicknamePlaceholder: "Write your nickname",
        deleteProgression: "Are you sure you want to delete your progression?",
        deleteProgressionButton: "Delete your progression of {mode} mode",
        or: 'OR',
        footer: <>
            <p>
                <strong>Pokémon</strong> and all associated trademarks are © Nintendo, Creatures, Game Freak, and The Pokémon Company. This is an unofficial, fan-made Pokémon Quiz created for non-profit purposes and is not affiliated with or endorsed by these entities.
            </p>
            <p>
                If you encounter bugs, have suggestions for improvements, or wish to share feedback, please feel free to contact me via the "About" page by clicking on "Contact Me." There, you'll also find a button for making donations.
                Your support and input are greatly appreciated!
            </p>
        </>,
        sharing: "Share your progression",
        routesDescription : ['Play', 'My Pokédex', 'Progression', 'Leaderboard', 'Daily Mission', 'About'],
        prizeWinner: <> Congratulations to <b>Justilikum</b>, <b>Serdelek8</b> & <b>Azip28</b> for winning the game's third prize by finding 60, 64 and 17 Pokémon respectively </>,
        back: "Back to Normal Mode"
    },
    fr: {
        infoRecord: "Prochain prix : 30 Nov 2025! Devine le max de Pokémon en 3 minutes - le premier gagne du cash! Clique ci-dessous pour jouer!",
        dialogReward: <ul>
            <li><strong>🕹️ Le but du jeu :</strong>Gagne un prix en trouvant le plus de Pokémon en 3 minutes chrono </li>
            <li>🔥 Pour commencer : Enregistre-toi avec un pseudo et adresse valide ci-dessous. Une fois fait, clique sur <strong>Start Timer</strong> le chrono sera lancé </li>
            <li><strong>📅 Défi Mensuel :</strong> Quatrième gagnant annoncé le <strong>30 Novembre 2025</strong> </li>
            <li>💲Cash-prize partagé entre les premiers de chaque pays </li>
        </ul>,
        labelDisplayPokemon: {autocomplete: 'Afficher les suggestions des Pokémon', random : 'Pokémon au hasard', order: 'Trié par ordre du Pokédex', gen: 'Par génération'},
        displayPokemon: "Choisissez le mode d'affichage des Pokémon",
        remainingPokemon: "Il vous reste encore {count} Pokémon à découvrir !",
        foundAll: "Vous avez trouvé tous les Pokémon possibles ! Réinitialisez votre progression pour réessayer.",
        switchModeButton: "Basculez vers le mode {mode}",
        sec: "secondes",
        start: 'Lancer le chrono',
        emailPlaceholder: "Écrivez votre email",
        nicknamePlaceholder: "Écrivez votre pseudo",
        deleteProgression: "Êtes-vous sûr de vouloir supprimer votre progression ?",
        deleteProgressionButton: "Supprimez votre progression du mode {mode}",
        or: 'OU',
        footer:
            <>
                <p>
                    <strong>Pokémon</strong> et toutes les marques associées sont © Nintendo, Creatures, Game Freak et The Pokémon Company. Ce site web est une création de fan, créé à des fins non lucratives, et n’est ni affilié ni approuvé par ces entités.
                </p>
                <p>
                    Si vous rencontrez des bugs, avez des suggestions d'améliorations ou souhaitez partager vos retours, n'hésitez pas à me contacter via la page "À propos" en cliquant sur "Contactez-moi." Vous y trouverez également un bouton pour effectuer des dons.
                    Votre soutien et vos retours sont grandement appréciés !
                </p>
            </>,
        sharing: "Partage ta progression",
        routesDescription: ['Jouez', 'Mon Pokédex', 'Progression', 'Top Classement', 'Mission Quotidienne', 'A propos'],
        prizeWinner: <> Bravo à <b>Justilikum</b>, <b>Serdelek8</b> et <b>Azip28</b> pour avoir remporté le troisième prix du jeu en trouvant respectivement 60, 64 et 17 Pokémon </>,
        back: "Retour au mode Normal"
    },
    de: {
        infoRecord: "Nächster Preis: 30 Nov 2025! Errate so viele Pokémon wie möglich in 3 Minuten – der beste Spieler gewinnt Bargeld! Tippe unten, um mitzumachen!",
        dialogReward:
            <ul>
                <li><strong>🕹️ Ziel des Spiels:</strong> Gewinne einen Preis, indem du in nur 3 Minuten die meisten Pokémon findest.</li>
                <li>🔥 So geht's: Registrieren Sie sich mit einem Spitznamen und einer gültigen E-Mail-Adresse. Klicken Sie anschließend auf <strong>Timer starten</strong>. Der Timer wird gestartet.</li>
                <li><strong>📅 Monatliche Herausforderung:</strong> Der dritte Gewinner wird am <strong>30. November 2025</strong> bekannt gegeben. </li>
                <li>💲Geldpreis für die besten Spieler jedes Landes </li>
            </ul>,
        labelDisplayPokemon: {autocomplete: 'Pokémon-Namensvorschläge anzeigen', random : 'Zufällig Pokémon', order: 'Sortiert nach Pokédex-Reihenfolge', gen: 'Nach Generation'},
        displayPokemon: 'Wählen Sie, wie die Pokémon angezeigt werden sollen',
        remainingPokemon: "Du hast noch {count} Pokémon zu entdecken!",
        foundAll: "Du hast alle möglichen Pokémon gefunden! Setze deinen Fortschritt zurück, um es erneut zu versuchen.",
        switchModeButton: "In den {mode}-Modus wechseln",
        sec: "sekunden",
        start: 'Timer starten',
        emailPlaceholder: "Schreibe deine E-Mail",
        nicknamePlaceholder: "Schreibe deinen Spitznamen",
        deleteProgression: "Sind Sie sicher, dass Sie Ihren Fortschritt löschen möchten?",
        deleteProgressionButton: "Löschen Sie Ihren Fortschritt aus dem {mode}-Modus",
        or: 'ODER',
        footer: <>
            <p>
                <strong>Pokémon</strong> und alle damit verbundenen Marken sind © Nintendo, Creatures, Game Freak und The Pokémon Company. Diese Website ist ein Fanprojekt, das nicht kommerziellen Zwecken dient und weder mit diesen Unternehmen verbunden noch von ihnen genehmigt ist.
            </p>
            <p>
                Bei Fehlern, Verbesserungsvorschlägen oder Feedback können Sie mich gerne über die Seite "Über uns" kontaktieren, indem Sie auf "Kontaktieren Sie mich" klicken. Dort finden Sie auch eine Schaltfläche, um Spenden zu leisten.
                Ich freue mich über Ihre Unterstützung und Ihr Feedback!
            </p>
        </>,
        sharing: "Teilt den Fortschritt",
        routesDescription: ['Spiele', 'Mein Pokédex', 'Fortschritt', 'Rangliste', 'Tägliche Mission', 'Über'],
        prizeWinner: <> Herzlichen Glückwunsch an <b>Justilikum</b>, <b>Serdelek8</b> und <b>Azip28</b> zum Gewinn des dritten Preises des Spiels, indem sie 60, 64 bzw. 17 Pokémon gefunden haben. </>,
        back: "Zurück zum Normalmodus"
    },
};

STRINGS['en']['prizeCondition'] = <> To have your name displayed on the leaderboards, access the game from the '{STRINGS.en.routesDescription[0]}' tab then on the '{STRINGS.en.switchModeButton.replace('{mode}', 'Record')}' button </>
STRINGS['fr']['prizeCondition'] = <> Pour avoir ton nom affiché sur le top classement, accède au jeu depuis l'onglet '{STRINGS.fr.routesDescription[0]}' puis sur le bouton '{STRINGS.fr.switchModeButton.replace('{mode}', 'Record')}'</>
STRINGS['de']['prizeCondition'] = <> Um Ihren Namen in den Bestenlisten anzuzeigen, rufen Sie das Spiel über die Registerkarte „{STRINGS.de.routesDescription[0]}“ auf und klicken Sie dann auf die Schaltfläche „{STRINGS.de.switchModeButton.replace('{mode}', 'Record')}“. </>

export const getLocalizedString = (langParam, key, params = {}) => {

    let localizedString = STRINGS[langParam][key] || key;


    Object.keys(params).forEach(param => {
        localizedString = localizedString.replace(`{${param}}`, params[param]);
    });
    return localizedString;
};